var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty-main"},[_c('Spin',{attrs:{"size":"large"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }